import { Reducer, createSlice } from "@reduxjs/toolkit";

const initialIssuesState: any = {};

const issuesSlice = createSlice({
  name: "issues",
  initialState: initialIssuesState,
  reducers: {
    setIssuesData: (state, action) => {
      for (const issue of action.payload) {
        if (state[issue.id]) {
          state[issue.id] = {
            ...state[issue.id],
            ...issue,
          };
        } else {
          state[issue.id] = issue;
        }
      }
    },
    updateIssuesData: (_state, action) =>
      action.payload.reduce((prev: any, curr: any) => {
        if (curr && curr.id) {
          return { ...prev, [curr.id]: curr };
        }
        return { ...prev };
      }, {}),
    modifyIssuesData: (state, action) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        ...action.payload,
      };
    },
    setIssuesCommentsData: (state, action) => {
      const { issueId, data, isEdit } = action.payload;
      const issueData = state[issueId] || {};
      let commentsData = {};
      if (Array.isArray(data)) {
        commentsData = data.reduce((prev, curr) => ({ ...prev, [curr._id]: curr }), {});
      } else if (typeof data === "object") {
        if (issueData.comments) {
          commentsData = isEdit
            ? {
                ...issueData.comments,
                [data._id]: {
                  ...issueData.comments[data._id],
                  ...data,
                },
              }
            : {
                [data._id]: data,
                ...issueData.comments,
              };
        } else {
          commentsData = {
            [data._id]: {
              ...data,
            },
          };
        }
      }
      state[issueId] = { ...issueData, comments: commentsData };
    },
    deleteIssuesCommentsData: (state, action) => {
      const { issueId, commentId } = action.payload;
      const issue = state[issueId];
      if (issue && issue.comments) {
        delete issue.comments[commentId];
      }
      state[issueId] = issue;
    },
    emptyIssuesData: () => ({}),
    mergeIssuesData: (state, action) => {
      const { data, editId } = action.payload;
      const issueId = data.id;
      if (editId) {
        state[editId] = { ...state[editId], ...data };
      } else {
        return { [issueId]: { ...data }, ...state };
      }
    },
    removeIssueFromState: (state, action) => {
      const { ids } = action.payload;
      ids.forEach((id: string) => {
        delete state[id];
      });
    },
    deleteIssuesData: (state, action) => {
      const issues = action.payload;
      issues.forEach((issue: any) => {
        delete state[issue];
      });
    },
    initializeIssuesData: () => initialIssuesState,
  },
});

export const {
  updateIssuesData,
  setIssuesData,
  modifyIssuesData,
  setIssuesCommentsData,
  deleteIssuesCommentsData,
  emptyIssuesData,
  mergeIssuesData,
  removeIssueFromState,
  deleteIssuesData,
  initializeIssuesData,
} = issuesSlice.actions;

const issueReducer: Reducer<any> = issuesSlice.reducer;
export default issueReducer;
